





























import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      category: "",
      categoryTitle: "",
      categoryToTitle: {
        pupils: "Pupils",
        parents: "Parents",
        staff: "Staff",
      },
    };
  },
  computed: {
    // categoryTitle() {
    //   return this.$router.currentRoute.name;
    // }
  },
  methods: {
    goto(category) {
      this.category = category;
      this.categoryTitle = this.categoryToTitle[category];
      Vue.nextTick(() => {
        // do something cool
        this.$router.push("/members/users/" + category);
      });
      // this.$forceUpdate();
    },
  },
  mounted() {
    this.categoryTitle = this.$router.currentRoute.name;
    this.$store.dispatch("loading", true);
  },
});
